import React from 'react';
import { cloneDeep, isEmpty } from 'lodash';
import { useSelector } from 'react-redux';
import { useComponent } from '../../UserSetting/UsersLibrary/UserRights';
import '../SystemMasters.css';
// eslint-disable-next-line import/order
import { useTranslation } from 'react-i18next';
import CustomTooltip from '../../../Components/Tooltip/CustomTooltip';

export default function DropdownCard({
  item,
  index,
  handleChanged,
  addValueForLabel,
  activeInactiveClicked,
  handleDelete,
  handleValueChanged,
  openList,
  setOpenList,
  masterAddEditAccess,
  masterDeleteAccess,
}) {
  const { t } = useTranslation('common');

  const { CheckActionPermission, createConditionalComponent } = useComponent();
  const reducer = useSelector((estate) => estate);
  const {
    Users: { logInRights },
  } = reducer;

  const MasterAddEditWrapper = createConditionalComponent(logInRights, 'masters', 'customAttribute', 'addEdit');
  const MasterDeleteWrapper = createConditionalComponent(logInRights, 'masters', 'customAttribute', 'delete');
  const MasterAddEditAccess = CheckActionPermission(logInRights, 'masters', 'customAttribute', 'addEdit');
  const handleOpenLabelOption = (optionIndex) => {
    let data = cloneDeep(openList);

    if (data.includes(optionIndex)) {
      const indexOf = data.indexOf(optionIndex);
      if (indexOf > -1) {
        data.splice(indexOf, 1); // 2nd parameter means remove one item only
      }
    } else {
      data = [index, ...data];
    }
    setOpenList(data);
  };

  return (
    <div className="d-flex align-items-center justify-content-center">
      <div className="card listing-card mx-12 p-2 mb-2 flex-fill" key={index}>
        <div className="dropdown-container">
          <div className="input-container">
            <div className="input-group form-floating-label fixed-label">
              <input
                key={index}
                name="freeLabel"
                autoFocus={!item?._id}
                value={item?.keyName ? item?.keyName : ''}
                placeholder={t('DROP_DOWN_CARD.ENTER_LABEL')}
                type="text"
                onChange={(e) => handleChanged(e, index)}
                className="form-control"
                disabled={!MasterAddEditAccess}
                maxLength={25}
              />
              <label className="asterisk-req">
                {t('DROP_DOWN_CARD.LABEL')}
                <span>*</span>
              </label>
            </div>
            {item?.isEmpty && (item?.keyName === null || item?.keyName === '') && (
              <label className="text-danger m-0 p-1">{t('DROP_DOWN_CARD.LABEL_REQUIRED')}</label>
            )}
          </div>
          <div className="input-action d-flex">
            {item?._id !== '' && masterAddEditAccess && (
              <>
                <MasterAddEditWrapper>
                  <CustomTooltip placement="bottom" tooltipText={t('CUSTOM_MODULE.ACTIVE_INACTIVE')}>
                    <button
                      type="button"
                      className=" mr-0"
                      onClick={() => activeInactiveClicked(item?._id)}
                      id={item?._id}
                      aria-label={item?.isActive ? 'Active' : 'Inactive'}
                    >
                      <span className={item.isActive ? 'icon-Eye-Open' : 'icon-Eye-Closed'} />
                    </button>
                  </CustomTooltip>
                </MasterAddEditWrapper>

                <MasterAddEditWrapper>
                  <CustomTooltip placement="bottom" tooltipText={t('CUSTOM_ATTRIBUTES.ADD_VALUE')}>
                    <button type="button" className=" mr-0" onClick={() => addValueForLabel(item?._id, index)} id={item?._id} aria-label="Add">
                      <span className="icon-add" />
                    </button>
                  </CustomTooltip>
                </MasterAddEditWrapper>
              </>
            )}
            <CustomTooltip placement="bottom" tooltipText={t('CUSTOM_ATTRIBUTES.ADD_OPTION')}>
              <button
                type="button"
                className="position-relative mr-0"
                onClick={() => {
                  handleOpenLabelOption(index);
                }}
              >
                {openList.includes(index) ? (
                  <span className="icon-new-down-arrow-icon icon-dropdown icon-inverse" />
                ) : (
                  <span className="icon-new-down-arrow-icon icon-dropdown" />
                )}
              </button>
            </CustomTooltip>

            {masterDeleteAccess && (
              <MasterDeleteWrapper>
                <CustomTooltip placement="bottom" tooltipText={t('CUSTOM_ATTRIBUTES.DELETE')}>
                  <button
                    type="button"
                    className=" mr-0"
                    onClick={() => {
                      handleDelete(item?._id ? item?._id : index);
                    }}
                    aria-label="delete"
                  >
                    <span className="icon-Delete f-24" />
                  </button>
                </CustomTooltip>
              </MasterDeleteWrapper>
            )}
          </div>
        </div>
        {!isEmpty(item?.options || []) ? (
          item?.options?.map((eleValue, indexValue) => {
            return (
              <div key={eleValue?._id} className={openList.includes(index) ? 'dropdown-items show' : 'dropdown-items '}>
                <div className="freetext-container mt-2 mx-0">
                  <div className="input-container">
                    <div className="input-group form-floating-label fixed-label">
                      <input
                        key={eleValue?._id}
                        name="freeLabel"
                        autoFocus={!eleValue._id}
                        disabled={!masterAddEditAccess}
                        value={eleValue.keyName ? eleValue.keyName : ''}
                        placeholder={t('DROP_DOWN_CARD.ENTER_VALUE')}
                        type="text"
                        onChange={(e) => handleValueChanged(e, indexValue, index)}
                        className="form-control"
                      />
                      <label className="asterisk-req">
                        {t('DROP_DOWN_CARD.VALUE')} {indexValue + 1}
                        <span>*</span>
                      </label>
                      {item?.isEmpty && (item?.keyName === null || item?.keyName === '') && (
                        <label className="text-danger m-0 p-1">{t('DROP_DOWN_CARD.VALUE_REQUIRED')}</label>
                      )}
                    </div>
                  </div>
                  <div className="input-action d-flex">
                    {eleValue._id !== '' && masterAddEditAccess && (
                      <MasterAddEditWrapper>
                        <CustomTooltip placement="top" tooltipText={t('CUSTOM_MODULE.ACTIVE_INACTIVE')}>
                          <button type="button" aria-label="button" className=" mr-0" onClick={() => activeInactiveClicked(item?._id, eleValue._id)}>
                            <span className={eleValue.isActive ? 'icon-Eye-Open' : 'icon-Eye-Closed'} />
                          </button>
                        </CustomTooltip>
                      </MasterAddEditWrapper>
                    )}
                    {masterDeleteAccess && (
                      <MasterDeleteWrapper>
                        <CustomTooltip placement="top" tooltipText={t('TEXT_CARD.DELETE')}>
                          <button
                            className=" mr-0"
                            type="button"
                            aria-label="Delete"
                            onClick={() => {
                              handleDelete(eleValue._id ? eleValue._id : indexValue, index);
                            }}
                          >
                            <span className="icon-Delete f-24" />
                          </button>
                        </CustomTooltip>
                      </MasterDeleteWrapper>
                    )}
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div className={openList?.includes(index) ? 'dropdown-items show' : 'dropdown-items '}>
            <p className="mt-3 mb-0 text-center">{t('DROP_DOWN_CARD.NO_OPTIONS_FOUND')}</p>
          </div>
        )}
      </div>
    </div>
  );
}
